import type { MyTurfAssignmentDto } from '../types/canvasser'
import type { QueuedRouteOutcome } from './offlineStore'

/**
 * [CF-1 P3] Show a queued action-route outcome ("Dropped off" / "Couldn't") as done on THAT turf only,
 * before it has synced (and after, until the next my-turfs read says so). Keyed by (turfId, contactId):
 * the same contact on a canvass turf is untouched. A rejected outcome is not overlaid: the server said
 * no, so the stop must not read done.
 */
export function applyRouteOutcomes(turfs: MyTurfAssignmentDto[], outcomes: QueuedRouteOutcome[]): MyTurfAssignmentDto[] {
  const live = outcomes.filter(o => o.rejected !== true)
  if (live.length === 0) return turfs
  const keys = new Set(live.map(o => `${o.outcome.turfId}|${o.outcome.contactId}`))
  return turfs.map(turf => {
    if (!turf.contacts.some(c => keys.has(`${turf.turfId}|${c.contactId}`))) return turf
    const contacts = turf.contacts.map(c =>
      keys.has(`${turf.turfId}|${c.contactId}`) ? { ...c, isVisited: true, followUpOpen: false } : c)
    return { ...turf, contacts, visitedCount: contacts.filter(c => c.isVisited).length }
  })
}
